<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		errorType: 'fetch' | 'empty';
		onRetry?: () => void;
	}

	const { errorType, onRetry }: Props = $props();

</script>

<div class="gap-2 flex flex-col items-center px-8">
	<div class="size-22.5 rounded-full flex justify-center items-center bg-neutral-soft">
		<Icon icon={errorType === 'fetch' ? 'feedback' : 'highlight-mouse-cursor'} class="size-12 text-coloredneutral-weak" />
	</div>
	<div>
		{#if errorType === 'fetch'}
			<div class="text-center">{m.poi_filters__fetch_error()}</div>
			<Button
				size="sm"
				icon="autorenew"
				text={m.action__retry()}
				class="m-auto mt-4"
				onclick={onRetry}
			/>
		{:else}
			<div class="text-center">{m.poi_filters__no_selected_categories()}</div>
			<div class="text-center">{m.poi_filters__select_to_filter()}</div>
		{/if}
	</div>
</div>
